import alert_mixin from "@/utils/mixins/alert_mixin";
import condition_question_assignment_mixin from "@/utils/mixins/compliance_mixins/condition_question_assignment_mixin";

export default {
  name: "ConditionQuestionAssignment",
  mixins: [alert_mixin, condition_question_assignment_mixin],

  props: {
    selected_rule: Object,
    selected_condition: Object,
    form_id: [String, Number],
    is_visible: Boolean,
  },

  data: () => ({
    questions: [],
    question_search: "",
    csrfToken: "",
    token: null,
    is_loading: false,
    pending_changes: [],
  }),
};
